import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  return <section className="bg-white py-12 md:py-24 px-4" data-id="element-269">
      <div className="max-w-5xl mx-auto" data-id="element-270">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-271">
          <span className="text-primary font-bold uppercase tracking-wider text-sm mb-2 block" data-id="element-272">
            Resultados Reales
          </span>
          <h2 className="text-3xl md:text-4xl text-dark font-display font-extrabold tracking-headline" data-id="element-273">
            Lo que dicen nuestras alumnas
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-274">
          {/* iOS Notification Style - Maria G. */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0
        }} className="bg-white rounded-2xl p-6 shadow-sm shadow-black/5 border border-stone-100" data-id="element-275">
            <div className="flex items-start gap-3 mb-4" data-id="element-276">
              <div className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center flex-shrink-0" data-id="element-277">
                <span className="text-stone-700 font-bold text-sm" data-id="element-278">MG</span>
              </div>
              <div className="flex-1" data-id="element-279">
                <div className="flex items-center justify-between mb-1" data-id="element-280">
                  <p className="font-bold text-dark text-sm" data-id="element-281">Maria G.</p>
                  <p className="text-xs text-stone-400" data-id="element-282">Hoy 10:23</p>
                </div>
                <p className="text-body text-sm leading-relaxed" data-id="element-283">
                  No puedo creerlo, configuré todo ayer y ya tuve mi primera
                  venta de $20 mientras hacía el almuerzo. ¡Gracias!
                </p>
              </div>
            </div>
          </motion.div>

          {/* iOS Notification Style - Carmen Rodriguez */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm shadow-black/5 border border-stone-100" data-id="element-284">
            <div className="flex items-start gap-3 mb-4" data-id="element-285">
              <div className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center flex-shrink-0" data-id="element-286">
                <span className="text-stone-700 font-bold text-sm" data-id="element-287">CR</span>
              </div>
              <div className="flex-1" data-id="element-288">
                <div className="flex items-center justify-between mb-1" data-id="element-289">
                  <p className="font-bold text-dark text-sm" data-id="element-290">
                    Carmen Rodriguez
                  </p>
                  <p className="text-xs text-stone-400" data-id="element-291">Hace 2h</p>
                </div>
                <p className="text-body text-sm leading-relaxed" data-id="element-292">
                  Por fin algo que no cuesta $500 usd y que sí explica cómo
                  hacerlo en lugar de tanta teoría.
                </p>
              </div>
            </div>
          </motion.div>

          {/* iOS Notification Style - Elena S. */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-2xl p-6 shadow-sm shadow-black/5 border border-stone-100" data-id="element-293">
            <div className="flex items-start gap-3 mb-4" data-id="element-294">
              <div className="w-10 h-10 rounded-full bg-stone-200 flex items-center justify-center flex-shrink-0" data-id="element-295">
                <span className="text-stone-700 font-bold text-sm" data-id="element-296">ES</span>
              </div>
              <div className="flex-1" data-id="element-297">
                <div className="flex items-center justify-between mb-1" data-id="element-298">
                  <p className="font-bold text-dark text-sm" data-id="element-299">Elena S.</p>
                  <p className="text-xs text-stone-400" data-id="element-300">Hace 1h</p>
                </div>
                <p className="text-body text-sm leading-relaxed" data-id="element-301">
                  Lo de la IA me voló la cabeza, me ahorró semanas de escritura.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}